/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.10.7",
    versionName: "0.7.0-nightly.2026.10.7",
    versionChannel: "nightly",
    buildDate: "2026-10-07T00:19:28.657Z",
    commitHash: "6ac5a3e47b94201f168906160db2ac7f9962f4a2",
};
